<template>
	<div>
		<a-page-header title="Companies">
			<template slot="extra">
				<a-button key="1" type="primary" @click="showAddModal()"
					>Add New Company</a-button
				>
				<a-button
					key="2"
					:disabled="selectedRowKeys.length == 0"
					type="primary"
					@click="preUpdateInstanceManager()"
					>Start Update Instance Manager</a-button
				>
				<a-popconfirm
					placement="topLeft"
					ok-text="Yes"
					cancel-text="No"
					@confirm="preUpdateAllCompanies()"
				>
					<template slot="title">
						<p>Update all companies</p>
						<p>Are you sure you want to update all companies at one go?</p>
					</template>
					<a-button key="3" type="dashed" danger>
						Update All Companies</a-button
					>
				</a-popconfirm>
				<a-button type="primary" @click="CheckSubscription()">Check Latest Status</a-button>
			</template>
		</a-page-header>
		<data-table
			ref="instancesDataTable"
			:columns="columns"
			:data-source="instancesState.instances"
			:loading="loading"
			@refreshData="fetchInstances"
			rowKey="id"
			:showRowSeletion="true"
			@onSelectChange="onSelectChange"
			:totalCount="instancesState.instancesCount"
		>
			<span slot="status" slot-scope="record">
				<a-tag v-if="record.subscriptionStatus == 5" :color="getBadgeColor(record.subscriptionStatus)">
					{{ getSuspendedBadgeText() }}
				</a-tag>
				<a-tag v-else :color="getBadgeColor(record.subscriptionStatus)">
					{{ getBadgeText(record.subscriptionStatus) }}
				</a-tag>
				<a-tooltip placement="topLeft">
					<template slot="title">
						<span>Trial expires on: {{ record.trialExpiresOn }}</span>
					</template>
					<a-tag v-if="record.isTrial && record.subscriptionStatus != 5" :color="badgeColor[1].color">
						{{ badgeColor[1].text }}
					</a-tag>
				</a-tooltip>
				<a-tag
					v-if="record.companySubscription.isUnsubscribe"
					:color="
						formateIsUnsubscribeTrueColor(
							record.companySubscription.isUnsubscribe
						)
					"
				>
					{{
						formateIsUnsubscribeTrueText(
							record.companySubscription.isUnsubscribe
						)
					}}
				</a-tag>
			</span>
			<span slot="accountHandler" slot-scope="record">
				<a-tooltip v-if="record.accountHandler">
					<template #title>
						{{
							`${record.accountHandler.firstname} ${
								record.accountHandler.lastname
							}  ${
								record.accountHandler.city
									? "|" + record.accountHandler.city
									: ""
							}`
						}}</template
					>
					{{
						`${record.accountHandler.initial} (${record.accountHandler.country.name})`
					}}
				</a-tooltip>
			</span>
			<span slot="salesHandler" slot-scope="record">
				<a-tooltip v-if="record.sales">
					<template #title>
						{{
							`${record.sales.name} ${
								record.sales.surname
							}`
						}}</template
					>
					{{
						`${record.sales.initial}`
					}}
				</a-tooltip>
			</span>
			<span slot="payment" slot-scope="record">
				<a-tag v-if="record.paymentMethod" color="blue">
					{{ record.paymentMethod }}
				</a-tag>
			</span>
			<span slot="location" slot-scope="record">
				<a-row>
					<a-tooltip :title="formateManualUpdateText(record.autoUpdate)">
						<a-tag
							v-if="record.instanceManager"
							:color="formateManualUpdateColor(record.autoUpdate)"
						>
							{{ record.instanceManager.name }}
						</a-tag>
					</a-tooltip>
				</a-row>
			</span>
			<span slot="price" slot-scope="record">
				£{{ priceText(record) }}
				<a-tooltip placement="topLeft">
					<template slot="title">
						<span>Plan Price is: £{{ planPriceText(record) }}</span>
					</template>
					<a-tag
						v-if="record.companySubscription.overrideUnitPrice !== null"
						color="red"
						style="margin-left: 15px"
					>
						Overrided
					</a-tag>
				</a-tooltip>
			</span>
			<span slot="url" slot-scope="record">
				<a :href="record.url" target="_blank">{{ record.url }}</a>
			</span>
			<span slot="autoUpdate" slot-scope="record">
				<a-tag :color="formateManualUpdateColor(record.autoUpdate)">
					{{ formateManualUpdateText(record.autoUpdate) }}
				</a-tag>
			</span>
			<span slot="startDate" slot-scope="record">
				<date-time-column v-model="record.companySubscription.startDate" />
			</span>
			<span slot="action" slot-scope="record">
				<a-tooltip title="Edit">
					<a class="action-icon" @click="showEditModal(record.id)"
						><a-icon type="edit"
					/></a>
				</a-tooltip>
				<a-divider type="vertical" />
				<a-tooltip title="Action Menu">
					<a-dropdown>
						<a class="action-icon"><a-icon type="menu" /></a>
						<a-menu slot="overlay">
							<a-menu-item>
								<div
									class="row"
									style="color: rgb(0, 123, 255)"
									@click="confirmDelete(record.id, record.name)"
								>
									<div class="col-1">
										<a-icon type="delete" />
									</div>
									<div class="col-2">Delete</div>
								</div>
							</a-menu-item>
							<a-menu-item>
								<div
									class="row"
									style="color: rgb(0, 123, 255)"
									@click="confirmSendWelcomeEmail(record.id)"
								>
									<div class="col-1">
										<a-icon type="mail" />
									</div>
									<div class="col-2">Send Welcome Email</div>
								</div>
							</a-menu-item>
							<a-menu-item>
								<div
									class="row"
									style="color: rgb(0, 123, 255)"
									@click="downloadConfig(record.id)"
								>
									<div class="col-1">
										<a-icon type="download" />
									</div>
									<div class="col-2">Config File</div>
								</div>
							</a-menu-item>
							<a-menu-item v-if="record.isTrial">
								<div
									class="row"
									style="color: rgb(0, 123, 255)"
									@click="showChangeTrialPeriodModal(record.id)"
								>
									<div class="col-1">
										<a-icon type="calendar" />
									</div>
									<div class="col-2">Manage Trial</div>
								</div>
							</a-menu-item>
							<a-menu-item>
								<div
									class="row"
									style="color: rgb(0, 123, 255)"
									@click="
										showRecreateModal(
											record.companySubscription.id,
											record.trialExpiresOn
										)
									"
								>
									<div class="col-1">
										<a-icon type="swap" />
									</div>
									<div class="col-2">Recreate</div>
								</div>
							</a-menu-item>
							<a-menu-item v-if="record.instanceManager">
								<div
									class="row"
									style="color: rgb(0, 123, 255)"
									@click="showMoveInstanceModal(record.id)"
								>
									<div class="col-1">
										<a-icon type="pull-request" />
									</div>
									<div class="col-2">Move Instance</div>
								</div>
							</a-menu-item>
							<a-menu-item
								v-if="
									record.instanceManager && record.supportUserExpire == null
								"
							>
								<div
									class="row"
									style="color: rgb(0, 123, 255)"
									@click="
										showAddSupportUserInstanceModal(record.id, record.name)
									"
								>
									<div class="col-1">
										<a-icon type="plus" />
									</div>
									<div class="col-2">Add Support User</div>
								</div>
							</a-menu-item>
						</a-menu>
					</a-dropdown>
				</a-tooltip>
			</span>
		</data-table>
		<EditInstanceModal
			v-if="isModalVisible"
			v-model="isModalVisible"
			:instance="currentInstance"
			:businesses="businessState.businesses"
			:plans="plansState.plansList"
			:channels="channelState.channels"
			:titles="titles"
			:modes="modes"
			:currentMode="currentMode"
			:isSaving="isSaving"
			:firmTypes="lookupState.firmTypes"
			:firmSizes="lookupState.firmSizes"
			:countries="lookupState.countries"
			@triggerUpdate="updateInstance"
			@triggerAdd="addInstance"
			@input="resetInstance"
			:accountHandlers="accountHandlerState.accountHandlers"
			:salesHandlers="salesHandlerState.salesHandlers"
		></EditInstanceModal>
		<ManageSubsPlanModal
			v-model="isManageModalVisible"
			title="Manage Subscription"
			:subscription="subscriptionToBeManaged"
			:plans="plansState.plans"
			:isSaving="isSaving"
			@input="resetSubscriptionToBeManaged"
			@add="addSubscription"
		></ManageSubsPlanModal>
		<ChangeTrialPeriodModal
			v-model="isChangeTrialPeriodModalVisible"
			title="Trial Period"
			:instance="currentInstance"
			:isSaving="isSaving"
			@input="resetChangeTrialPeriod"
			@activateSubscription="activateSubscription"
			@terminateTrial="terminateTrial"
			@changeTrialPeriodEndDate="changeTrialPeriodEndDate"
		></ChangeTrialPeriodModal>
		<RecreateModal
			v-model="isRecreateModalVisible"
			title="Recreate Subscription"
			:plans="plansState.plansList"
			:trialEnd="selectedTrialEnd"
			:isSaving="isSaving"
			:companySubscriptionId="selectedCompanySubscriptionId"
			@onSaved="closeRecreateModel"
		></RecreateModal>
		<DeleteCompanyConfirm
			:companyName="toBeDeletedName"
			:loading="isDeleteLoading"
			v-model="showDelete"
			@delete="deleteInstance"
		/>
		<AddSupportUserConfirm
			:companyName="toBeDeletedName"
			:loading="isDeleteLoading"
			v-model="showAddSupport"
			@addUser="addSupportUser"
		/>
		<template>
			<a-modal
				v-model="showProgressModal"
				class="text-center"
				:closable="false"
				:keyboard="false"
				:maskClosable="false"
			>
				<template slot="footer">
					<a-button
						key="submit"
						type="primary"
						:loading="this.percentUpdateInstanceManager != 100"
						@click="onFinish()"
					>
						Finish
					</a-button>
				</template>
				<a-progress type="circle" :percent="percentUpdateInstanceManager" />
			</a-modal>
		</template>
		<MoveInstanceModal
			v-model="isMoveInstanceModalVisible"
			:loading="isMoveInstanceLoading"
			:companyName="currentInstance.name"
			:oldInstanceManager="currentInstance.instanceManager"
			:companyId="currentInstance.id"
			@moveInstance="moveInstance"
		/>
		<template>
			<TempPassConfirm
				v-model="showCheckTempPass"
				@confirm="checkTempPass"
				@close="closeTempPassConfirm"
				:Closable="true"
			></TempPassConfirm>
		</template>
	</div>
</template>

<script>
import {
	instancesState,
	instancesMutations,
	plansState,
	plansMutations,
	businessState,
	businessMutations,
	lookupState,
	lookupMutations,
	channelState,
	channelMutations,
	instanceManagerMutations,
	accountHandlerState,
	accountHandlerMutations,
	salesHandlerMutations,
	salesHandlerState,
} from "../../Store/store.js";
import moment from "moment";
import EditInstanceModal from "./EditInstanceModal.vue";
import ManageSubsPlanModal from "./ManageSubsPlanModal.vue";
import ChangeTrialPeriodModal from "./ChangeTrialPeriodModal.vue";
import RecreateModal from "./RecreateModal.vue";
import DeleteCompanyConfirm from "./DeleteCompanyConfirm.vue";
import AddSupportUserConfirm from "./AddSupportUserConfirm.vue";
import MoveInstanceModal from "./MoveInstanceModal.vue";
import TempPassConfirm from "../Share/TempPassConfirm.vue";

const MESSAGES = {
	instanceDeletedSuccess: "Instance deleted successfully",
	supportUserAdded: "Support user added.",
	instanceDeletedFailure: "Failure while deleting the instance",
};
const MODES = {
	add: "add",
	edit: "edit",
};
const DEFAULT_INSTANCE = {
	isActive: true,
	autoUpdate: true,
	business: {},
	contactPerson: {},
	companySubscription: {
		startDate: moment().format("DD/MM/YYYY"),
		subscriptionPlan: {},
	},
	firmType: {},
	firmSize: {},
	channel: {},
	address: { countryId: 230 },
	name: "",
	url:""
};
const columns = [
	{
		title: "Name",
		dataIndex: "name",
		key: "name",
		sorter: true,
		ellipsis: true,
		width: "12%",
	},
	{
		title: "Status",
		key: "isActive",
		scopedSlots: { customRender: "status" },
		ellipsis: true,
		width: "13%",
	},
	{
		title: "Payment",
		key: "isPayment",
		scopedSlots: { customRender: "payment" },
		width: "5.3%",
	},
	{
		title: "Server",
		key: "isLocation",
		scopedSlots: { customRender: "location" },
		ellipsis: true,
	},
	{
		title: "Account Handler",
		key: "accountHandler",
		scopedSlots: { customRender: "accountHandler" },
		ellipsis: true,
	},
	{
		title: "Sales",
		key: "salesHandler",
		scopedSlots: { customRender: "salesHandler" },
		ellipsis: true,
		width: "3.7%",
	},
	{
		title: "GLS Version",
		dataIndex: "glsVersion",
		key: "glsVersion",
	},
	{
		title: "Plan",
		dataIndex: "companySubscription.subscriptionPlan.name",
		key: "companySubscription.subscriptionPlan.name",
		ellipsis: true,
	},
	{
		title: "Unit Price",
		key: "price",
		scopedSlots: { customRender: "price" },
		ellipsis: true,
	},
	{
		title: "total subscribers",
		dataIndex: "companySubscription.subscriptionQuantity",
		key: "companySubscription.subscriptionQuantity",
		ellipsis: true,
		width: "3.7%",
	},
	{
		title: "Start Date",
		scopedSlots: { customRender: "startDate" },
		key: "startDate",
		ellipsis: true,
	},
	{
		title: "URL",
		key: "url",
		scopedSlots: { customRender: "url" },
		ellipsis: true,
	},
	{
		title: "Actions",
		key: "action",
		scopedSlots: { customRender: "action" },
		ellipsis: true,
		width: 70,
	},
];

const titles = ["Mr", "Mrs"];

export default {
	async mounted() {
		await this.fetchInstances();
		await this.fetchPlans();
		await businessMutations.setBusinesses();
		await lookupMutations.getFirmTypes();
		await lookupMutations.getFirmSizes();
		await lookupMutations.getCountries();
		await channelMutations.setChannels();
		await accountHandlerMutations.setAccountHandler();
		await salesHandlerMutations.getSales();
	},
	data() {
		return {
			instanceManagerMutations,
			accountHandlerState,
			salesHandlerState,
			businessState: businessState,
			columns: columns,
			currentInstance: {
				isActive: true,
				autoUpdate: true,
				business: {},
				contactPerson: {},
				companySubscription: {
					startDate: moment().format("DD/MM/YYYY"),
					subscriptionPlan: {},
				},
				firmType: {},
				firmSize: {},
				channel: {},
				address: { countryId: 230 },
				name: "",
				url: "",
			},
			currentMode: null,
			instancesState: instancesState,
			isDeleteInstanceModalVisible: false,
			isManageModalVisible: false,
			isChangeTrialPeriodModalVisible: false,
			isRecreateModalVisible: false,
			isModalVisible: false,
			isSaving: false,
			loading: false,
			modes: MODES,
			plansState: plansState,
			lookupState: lookupState,
			lookupMutations: lookupMutations,
			subscriptionToBeManaged: {},
			titles: titles,
			toBeDeletedId: null,
			toBeDeletedName: null,
			sendEmailInstanceId: null,
			selectedCompanySubscriptionId: null,
			selectedTrialEnd: null,
			badgeColor: {
				1: { color: "orange", text: "Trial" },
				2: { color: "green", text: "Active" },
				3: { color: "red", text: "Inactive" },
				4: { color: "red", text: "Manual Update" },
				5: { color: "purple", text: "Unsubscribed" },
				6: { color: "purple", text: "Auto Update" },
				7: { color: "red", text: "Suspended" },
			},
			channelState,
			channelMutations,
			selectedRowKeys: [],
			showProgressModal: false,
			percentUpdateInstanceManager: 0,
			pageSize: 15,
			showDelete: false,
			showAddSupport: false,
			isDeleteLoading: false,
			isMoveInstanceLoading: false,
			isMoveInstanceModalVisible: false,
			isTempPassConfirmed: false,
			showCheckTempPass: false,
			UpdateInstanceManagerMode: false,
			UpdateAllCompaniesMode: false,
		};
	},
	methods: {
		async fetchPlans() {
			await plansMutations.getPlansList();
		},
		async fetchInstances(params = {}) {
			this.loading = true;
			await instancesMutations.getInstances(params);
			this.loading = false;
		},
		getCurrentInstance(instanceId) {
			const instance = {
				...this.instancesState.instances.find((i) => i.id == instanceId),
			};
			instance.contactPerson = instance.contactPerson ?? {};
			instance.companySubscription = instance.companySubscription ?? {};

			return instance;
		},
		async downloadConfig(recordId) {
			await instancesMutations.downloadInstanceConfig(recordId);
		},
		confirmDelete(recordId, name) {
			this.toBeDeletedId = recordId;
			this.toBeDeletedName = name;
			this.showDelete = true;
		},
		async deleteInstance(confirmDeleteModel) {
			let selectedInstance = {
				...this.instancesState.instances.find(
					(i) => i.id == this.toBeDeletedId
				),
			};
			let deleteInstanceRequestBody = {
				id: selectedInstance.id,
				businessId: selectedInstance.business.id,
				tokenKey: selectedInstance.business.tokenKey,
				keepBackup: confirmDeleteModel.keepBackup,
				password: confirmDeleteModel.password,
				companyName: confirmDeleteModel.companyName,
			};
			try {
				this.isDeleteLoading = true;
				let deleteResponse = await instancesMutations.deleteInstance(
					deleteInstanceRequestBody
				);
				if (deleteResponse?.status == 200) {
					this.$message.success(MESSAGES.instanceDeletedSuccess);
					this.showDelete = false;
					this.$refs.instancesDataTable.refreshData(true);
					this.selectedRowKeys = [];
				}
				this.isDeleteLoading = false;
			} catch (error) {
				this.isDeleteLoading = false;
				this.showError(error);
			}
		},
		async addSupportUser(confirmAddSupportModel) {
			let selectedInstance = {
				...this.instancesState.instances.find(
					(i) => i.id == this.toBeDeletedId
				),
			};
			let addSupportUserRequest = {
				id: this.toBeDeletedId,
				businessId: selectedInstance.business.id,
				tokenKey: selectedInstance.business.tokenKey,
				password: confirmAddSupportModel.password,
				companyName: confirmAddSupportModel.companyName,
			};
			try {
				this.isDeleteLoading = true;
				let deleteResponse = await instanceManagerMutations.addSupportUser(
					addSupportUserRequest
				);
				if (deleteResponse?.status == 200) {
					this.$message.success(MESSAGES.supportUserAdded);
					this.showAddSupport = false;
					this.$refs.instancesDataTable.refreshData(true);
					this.selectedRowKeys = [];
				}
				this.isDeleteLoading = false;
			} catch (error) {
				this.isDeleteLoading = false;
				this.showError(error);
			}
		},
		showAddModal() {
			this.currentInstance = {
				isActive: true,
				autoUpdate: true,
				business: {},
				contactPerson: {},
				companySubscription: {
					startDate: moment().format("DD/MM/YYYY"),
					subscriptionPlan: {},
				},
				firmType: {},
				firmSize: {},
				channel: {},
				address: { countryId: 230 },
				name: "",
				url: "",
			};
			this.showModal(this.modes.add);
		},
		showEditModal(instanceId) {
			this.currentInstance = this.getCurrentInstance(instanceId);
			this.showModal(this.modes.edit);
		},
		async updateInstance(updatedInstance) {
			try {
				this.isSaving = true;
				let updateResonse = await instancesMutations.updateInstance(
					updatedInstance
				);
				this.showSuccess(updateResonse);
			} catch (error) {
				this.showError(error);
			} finally {
				this.isSaving = false;
				this.isModalVisible = false;
				this.$refs.instancesDataTable.refreshData();
			}
		},
		async addInstance(newInstance) {
			try {
				this.isSaving = true;
				await instancesMutations.addInstance(newInstance);
				this.isModalVisible = false;
			} catch (error) {
				this.showError(error);
			} finally {
				this.isSaving = false;
			}
		},
		showModal(mode) {
			this.currentMode = mode;
			this.isModalVisible = true;
		},
		resetInstance() {
			this.isModalVisible = false;
			this.currentInstance = DEFAULT_INSTANCE;
		},
		showManageModal(instanceId) {
			this.subscriptionToBeManaged = {
				startDate: moment().add(1).format("DD/MM/YYYY"),
				subscriptionPlanId: 1,
				subscriptionQuantity: null,
				companyId: instanceId,
			};
			this.isManageModalVisible = true;
		},
		resetSubscriptionToBeManaged() {
			this.subscriptionToBeManaged = {};
		},
		async addSubscription(subscription) {
			let company = {
				...this.instancesState.instances.find(
					(i) => i.id == subscription.companyId
				),
			};
			const tokenKey = this.businessState.businesses.find(
				(b) => b.id === company.businessId
			)?.tokenKey;
			this.isSaving = true;
			try {
				var response = await instancesMutations.addSubscription({
					token: company.token,
					tokenKey: tokenKey,
					...subscription,
				});
				this.showSuccess(response);
			} catch (error) {
				this.showError(error);
			} finally {
				this.isSaving = false;
				this.isManageModalVisible = false;
			}
		},
		confirmSendWelcomeEmail(instanceId) {
			let self = this;
			this.$confirm({
				title: "Send Welcome Email",
				content:
					"Welcome email will be send to te company owner. Are you sure about sending this email?",
				okText: "Send Email",
				cancelText: "Cancel",
				onOk() {
					self.sendWelcomeEmail(instanceId);
				},
				onCancel() {},
			});
		},
		async sendWelcomeEmail(instanceId) {
			try {
				var response = await instancesMutations.sendWelcomeEmail({
					companyId: instanceId,
				});
				this.showSuccess(response);
			} catch (error) {
				this.showError(error);
			}
		},
		showChangeTrialPeriodModal(instanceId) {
			this.currentInstance = this.getCurrentInstance(instanceId);
			this.isChangeTrialPeriodModalVisible = true;
		},
		preUpdateInstanceManager() {
			this.showCheckTempPass = true;
			this.UpdateInstanceManagerMode = true;
		},
		async UpdateInstanceManager() {
			let step = Math.ceil(100 / this.selectedRowKeys.length);
			this.showProgressModal = true;
			this.selectedRowKeys.forEach(async (element) => {
				try {
					await instanceManagerMutations.EditInstance(element);
					if (this.percentUpdateInstanceManager + step > 100) {
						this.percentUpdateInstanceManager = 100;
					} else {
						this.percentUpdateInstanceManager += step;
					}
				} catch (error) {
					this.percentUpdateInstanceManager += step;
					this.showError(error);
				}
			});
			return;
		},
		showRecreateModal(companySubscriptionId, trialEnd) {
			this.isRecreateModalVisible = true;
			this.selectedCompanySubscriptionId = companySubscriptionId;
			this.selectedTrialEnd = trialEnd;
		},
		showMoveInstanceModal(instanceId) {
			this.currentInstance = this.getCurrentInstance(instanceId);
			this.isMoveInstanceModalVisible = true;
		},
		showAddSupportUserInstanceModal(id, name) {
			this.toBeDeletedId = id;
			this.toBeDeletedName = name;
			this.showAddSupport = true;
		},
		closeRecreateModel() {
			this.isRecreateModalVisible = false;
			this.selectedCompanySubscriptionId = null;
			this.selectedTrialEnd = null;
		},
		resetChangeTrialPeriod() {
			this.isChangeTrialPeriodModalVisible = false;
			this.currentInstance = DEFAULT_INSTANCE;
		},
		async changeTrialPeriodEndDate(companySubscriptionId, trialEnd) {
			this.isSaving = true;

			try {
				var response = await instancesMutations.extendTrialPeriod({
					companySubscriptionId,
					trialEnd,
				});
				this.showSuccess(response);
				this.resetChangeTrialPeriod();
			} catch (error) {
				this.showError(error);
			} finally {
				this.isSaving = false;
			}
		},
		async terminateTrial(companySubscriptionId) {
			this.isSaving = true;

			try {
				var response = await instancesMutations.terminateTrialSubscription(
					companySubscriptionId
				);
				this.showSuccess(response);
				this.resetChangeTrialPeriod();
			} catch (error) {
				this.showError(error);
			} finally {
				this.isSaving = false;
			}
		},
		async activateSubscription(companySubscriptionId) {
			this.isSaving = true;

			try {
				var response = await instancesMutations.endTrialPeriod(
					companySubscriptionId
				);
				this.showSuccess(response);
				this.resetChangeTrialPeriod();
			} catch (error) {
				this.showError(error);
			} finally {
				this.isSaving = false;
			}
		},
		getBadgeColor(status) {
			return [1, 2].includes(status)
				? this.badgeColor[2].color
				: this.badgeColor[3].color
		},
		getSuspendedBadgeText(){
			return this.badgeColor[7].text;
		},
		getBadgeText(status) {
			return [1, 2].includes(status)
				? this.badgeColor[2].text
				: this.badgeColor[3].text;
		},
		priceText(record) {
			const planPrice = record.companySubscription.subscriptionPlan.price;
			const overridePrice = record.companySubscription.overrideUnitPrice;

			if (overridePrice !== null) {
				return `${overridePrice
					.toString()
					.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
			} else {
				return `${planPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
			}
		},
		planPriceText(record) {
			const planPrice = record.companySubscription.subscriptionPlan.price;
			return `${planPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`;
		},
		onSelectChange(selectedRowKeys) {
			this.selectedRowKeys = selectedRowKeys;
		},
		onFinish() {
			this.showProgressModal = false;
			this.percentUpdateInstanceManager = 0;
			this.$refs.instancesDataTable.refreshData();
		},
		formateManualUpdateColor(autoUpdate) {
			if (!autoUpdate) return this.badgeColor[4].color;
			return this.badgeColor[6].color;
		},
		formateManualUpdateText(autoUpdate) {
			if (!autoUpdate) return this.badgeColor[4].text;
			return this.badgeColor[6].text;
		},
		formateIsUnsubscribeTrueColor(isSubscribe) {
			if (isSubscribe) return this.badgeColor[5].color;
		},
		formateIsUnsubscribeTrueText(isSubscribe) {
			if (isSubscribe) return this.badgeColor[5].text;
		},
		async moveInstance(confirmMove) {
			try {
				this.isMoveInstanceLoading = true;
				await instanceManagerMutations.moveInstance(confirmMove);
				this.showSuccess("move instance successfully");
				this.isMoveInstanceLoading = false;
				this.isMoveInstanceModalVisible = false;
				this.$refs.instancesDataTable.refreshData(true);
			} catch (error) {
				this.isMoveInstanceLoading = false;
				this.showError(error);
			}
		},
		async checkTempPass() {
			this.showCheckTempPass = false;
			this.isTempPassConfirmed = true;
			if (this.UpdateAllCompaniesMode) {
				await this.UpdateAllCompanies();
				this.UpdateAllCompaniesMode = false;
			} else if (this.UpdateInstanceManagerMode) {
				await this.UpdateInstanceManager();
				this.UpdateInstanceManagerMode = false;
			}
		},
		preUpdateAllCompanies() {
			this.showCheckTempPass = true;
			this.UpdateAllCompaniesMode = true;
		},
		async UpdateAllCompanies() {
			try {
				this.loading = true;
				await instanceManagerMutations.UpdateAllCompanies();
				this.loading = false;
				this.showSuccess("Update all instances successfully");
				this.$refs.instancesDataTable.refreshData(true);
			} catch (error) {
				this.loading = false;
				this.showError(error);
			}
		},
		closeTempPassConfirm() {
			this.showCheckTempPass = false;
			this.UpdateAllCompaniesMode = false;
			this.UpdateInstanceManagerMode = false;
		},
		async CheckSubscription() {
				try {
					let checkResponse =
						await this.instanceManagerMutations.CheckSubscriptionPaid();
					if (checkResponse?.status == 200) {
						this.$message.success("Check Completed successfully!");
					}
				} catch (error) {
					this.showError(error);
				} finally {
					this.$refs.instancesDataTable.refreshData(true);
				}
			},
			
	},
	components: {
		EditInstanceModal,
		ManageSubsPlanModal,
		ChangeTrialPeriodModal,
		RecreateModal,
		DeleteCompanyConfirm,
		MoveInstanceModal,
		AddSupportUserConfirm,
		TempPassConfirm,
	},
};
</script>

<style scoped>
.trash-icon:hover {
	color: #bb2020;
}

.action-icon:hover {
	color: #121317;
}
</style>
